// import { createContext, useContext, useEffect, useRef, useState } from "react";

// const WebSocketContext = createContext(null);

// export const WebSocketProvider = ({ children }) => {
//     const [messages, setMessages] = useState([]);
//     console.log('messages', messages)
//     const socketRef = useRef(null);
//     const retryDelayRef = useRef(1000);
//     const reconnectTimeoutRef = useRef(null);
//     const [userId, setUserId] = useState(localStorage.getItem("userId"));

//     useEffect(() => {
//         const interval = setInterval(() => {
//             const storedUserId = localStorage.getItem("userId");
//             if (storedUserId && storedUserId !== userId) {
//                 setUserId(storedUserId);
//             }
//         }, 2000);

//         return () => clearInterval(interval);
//     }, [userId]);

//     //Many servers close idle connections after 30–60s. You should keep the connection alive
//     useEffect(() => {
//         const pingInterval = setInterval(() => {
//             if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
//                 socketRef.current.send(JSON.stringify({ type: "ping" }));
//             }
//         }, 20000); // every 20 seconds

//         return () => clearInterval(pingInterval);
//     }, []);

//     const connectWebSocket = () => {
//         if (!userId) {
//             console.warn("🚨 WebSocket: Waiting for userId...");
//             return;
//         }

//         console.log("🔗 Connecting to WebSocket:", process.env.REACT_APP_WEBSOCKET);
//         const ws = new WebSocket(process.env.REACT_APP_WEBSOCKET);

//         socketRef.current = ws;


//         if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
//             console.log("🛑 WebSocket already open");
//             return;
//         }


//         //And reset the delay after a successful connection
//         ws.onopen = () => {
//             retryDelayRef.current = 1000;
//             ws.send(JSON.stringify({ type: "join", userId }));
//             console.log("✅ WebSocket connected successfully.");
//         };

//         ws.onmessage = (event) => {
//             const data = JSON.parse(event.data);
//             console.log('🔥 got push:', data);
//             setMessages((prevMessages) => [...prevMessages, data]);
//         };

//         // ws.onclose = () => {
//         //     console.log("❌ WebSocket disconnected. Reconnecting...");
//         //     reconnectTimeoutRef.current = setTimeout(connectWebSocket, 5000);
//         // };


//         //Currently, it reconnects every 5s, even if the server is down. Add a backoff strategy
//         ws.onclose = () => {
//             console.log("❌ WebSocket disconnected. Reconnecting...");
//             reconnectTimeoutRef.current = setTimeout(() => {
//                 retryDelayRef.current = Math.min(retryDelayRef.current * 2, 30000); // max 30s
//                 connectWebSocket();
//             }, retryDelayRef.current);
//         };



//         ws.onerror = (error) => {
//             console.error("⚠️ WebSocket Error:", error);
//             ws.close();
//         };
//     };

//     //Mobile devices often lose connectivity temporarily. Listen for it
//     useEffect(() => {
//         const handleOnline = () => {
//             if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
//                 console.log("📶 Network online. Reconnecting WebSocket...");
//                 connectWebSocket();
//             }
//         };

//         window.addEventListener("online", handleOnline);
//         return () => window.removeEventListener("online", handleOnline);
//     }, []);

//     useEffect(() => {
//         if (userId) {
//             connectWebSocket();
//         }

//         return () => {
//             if (socketRef.current) socketRef.current.close();
//             clearTimeout(reconnectTimeoutRef.current);
//         };
//     }, [userId]);

//     const sendMessage = (message) => {
//         if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
//             console.log("🚀 Sending WebSocket Message:", message);
//             socketRef.current.send(JSON.stringify(message));
//         } else {
//             console.log("⚠️ WebSocket Not Open. Message Not Sent.");
//         }
//     };

//     return (
//         <WebSocketContext.Provider value={{ messages, sendMessage }}>
//             {children}
//         </WebSocketContext.Provider>
//     );
// };

// export const useWebSocket = () => useContext(WebSocketContext);


import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
    const [messages, setMessages] = useState([]);
    const socketRef = useRef(null);
    const reconnectTimeoutRef = useRef(null);
    const [userId, setUserId] = useState(localStorage.getItem("userId"));
    const preventReconnect = useRef(false); // ✅ block reconnect if needed

    // join-ack watchdog (resend firstJoin if ack not received)
    const joinAckTimerRef = useRef(null);
    const joinAckRetriesRef = useRef(0);
    const joinAckReceivedRef = useRef(false);

    const clearJoinAckWatchdog = useCallback(() => {
        if (joinAckTimerRef.current) {
            clearTimeout(joinAckTimerRef.current);
            joinAckTimerRef.current = null;
        }
    }, []);

    // Sync userId with localStorage every 2 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            const storedUserId = localStorage.getItem("userId");
            if (storedUserId && storedUserId !== userId) {
                setUserId(storedUserId);
            }
        }, 2000);
        return () => clearInterval(interval);
    }, [userId]);

    const disconnectWebSocket = useCallback(() => {
        preventReconnect.current = true; // ✅ block reconnect

        clearJoinAckWatchdog();
        joinAckRetriesRef.current = 0;
        joinAckReceivedRef.current = false;

        if (socketRef.current) {
            socketRef.current.close();
            socketRef.current = null;
        }
        if (reconnectTimeoutRef.current) {
            clearTimeout(reconnectTimeoutRef.current);
            reconnectTimeoutRef.current = null;
        }
    }, [clearJoinAckWatchdog]);

    const connectWebSocket = useCallback(() => {
        if (!userId) {
            // console.warn("🚨 WebSocket: Waiting for userId...");
            return;
        }

        // console.log("🔗 Connecting to WebSocket:",userId, process.env.REACT_APP_WEBSOCKET);
        const ws = new WebSocket(process.env.REACT_APP_WEBSOCKET);

        socketRef.current = ws;

        const scheduleFirstJoinRetry = () => {
            clearJoinAckWatchdog();
            joinAckTimerRef.current = setTimeout(() => {
                if (joinAckReceivedRef.current) return;
                if (ws.readyState !== WebSocket.OPEN) return;

                joinAckRetriesRef.current += 1;
                const maxRetries = 10;

                if (joinAckRetriesRef.current <= maxRetries) {
                    console.warn(
                        `⚠️ No join-ack received; resending firstJoin (attempt ${joinAckRetriesRef.current}/${maxRetries})`,
                        userId
                    );
                    try {
                        ws.send(JSON.stringify({ type: "firstJoin", userId }));
                    } catch (e) {
                        console.error("⚠️ Failed to resend firstJoin:", e);
                    }
                    scheduleFirstJoinRetry();
                } else {
                    console.error("❌ join-ack not received after retries; closing socket to reconnect.");
                    try {
                        ws.close();
                    } catch (e) {
                        console.error("⚠️ Failed to close socket after join-ack timeout:", e);
                    }
                }
            }, 5000);
        };

        ws.onopen = () => {
            joinAckReceivedRef.current = false;
            joinAckRetriesRef.current = 0;
            ws.send(JSON.stringify({ type: "join", userId }));
            // console.log("✅ WebSocket connected successfully.", userId);
        };

        ws.onmessage = (event) => {
            const data = JSON.parse(event.data);
            // console.log("🔥 got push:", data);
            if (data?.type === "join-ack") {
                joinAckReceivedRef.current = true;
                clearJoinAckWatchdog();
                if (data.ok) {
                        if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(position => {
                                sendMessage({
                                    type: 'update-location-vendor',
                                    userId: userId,
                                    location: {
                                        ltd: position.coords.latitude,
                                        lng: position.coords.longitude
                                    }
                                })
                            })
                        }
                    console.log("✅ WebSocket connected successfully.", data.userId);
                } else {
                    console.warn("⚠️ WebSocket join failed:", data.message);
                }
                return;
            }
            if (data.message === "logout-session") {
                localStorage.clear();
                sessionStorage.clear();
                setMessages([]);
                disconnectWebSocket(); // ✅ clean disconnect
                window.location.href = "/LoginPage";
                return;
            }

            setMessages((prevMessages) => [...prevMessages, data]);
        };

        ws.onclose = () => {
            // console.log("❌ WebSocket disconnected.");
            console.log("❌ WebSocket disconnected.");
            clearJoinAckWatchdog();
            if (!preventReconnect.current) {
                // console.log("🔁 Reconnecting WebSocket...");
                reconnectTimeoutRef.current = setTimeout(connectWebSocket, 5000);
            }
        };

        ws.onerror = (error) => {
            // console.error("⚠️ WebSocket Error:", error);
            ws.close();
        };
    }, [clearJoinAckWatchdog, disconnectWebSocket, userId]);

    useEffect(() => {
        if (userId) {
            preventReconnect.current = false; // allow reconnect
            connectWebSocket();
        }

        return () => {
            disconnectWebSocket(); // clean up on unmount
        };
    }, [connectWebSocket, disconnectWebSocket, userId]);

    const sendMessage = (message) => {
        if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
            // console.log("🚀 Sending WebSocket Message:", message);
            socketRef.current.send(JSON.stringify(message));
        } else {
            // console.log("⚠️ WebSocket Not Open. Message Not Sent.");
        }
    };

    return (
        <WebSocketContext.Provider
            value={{
                messages,
                setMessages,
                sendMessage,
                connectWebSocket,
                disconnectWebSocket,
                socketRef,
            }}
        >
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocket = () => useContext(WebSocketContext);


// import { createContext, useContext, useEffect, useRef, useState } from "react";

// const WebSocketContext = createContext(null);

// export const WebSocketProvider = ({ children }) => {
//     const [messages, setMessages] = useState([]);
//     console.log('messages', messages)
//     const socketRef = useRef(null);
//     const reconnectTimeoutRef = useRef(null);
//     const [userId, setUserId] = useState(localStorage.getItem("userId"));

//     useEffect(() => {
//         const interval = setInterval(() => {
//             const storedUserId = localStorage.getItem("userId");
//             if (storedUserId && storedUserId !== userId) {
//                 setUserId(storedUserId);
//             }
//         }, 2000);

//         return () => clearInterval(interval);
//     }, [userId]);

//     const connectWebSocket = () => {
//         if (!userId) {
//             console.warn("🚨 WebSocket: Waiting for userId...");
//             return;
//         }

//         console.log("🔗 Connecting to WebSocket:", process.env.REACT_APP_WEBSOCKET);
//         const ws = new WebSocket(process.env.REACT_APP_WEBSOCKET);

//         socketRef.current = ws;

//         ws.onopen = () => {
//             ws.send(JSON.stringify({ type: "join", userId }));
//             console.log("✅ WebSocket connected successfully.");
//         };

//         ws.onmessage = (event) => {
//             const data = JSON.parse(event.data);
//             console.log('🔥 got push:', data);
//             if (data.message === 'logout-session') {
//                 // Clear storage
//                 localStorage.clear();
//                 sessionStorage.clear();

//                 // Clear state
//                 setMessages([]);

//                 // Close WebSocket and prevent reconnect
//                 if (socketRef.current) {
//                     socketRef.current.close(); // Close WebSocket
//                     socketRef.current = null;
//                 }

//                 clearTimeout(reconnectTimeoutRef.current); // Stop reconnect attempts

//                 // Redirect
//                 window.location.href = '/LoginPage';
//                 return;
//             }
//             setMessages((prevMessages) => [...prevMessages, data]);
//         };

//         ws.onclose = () => {
//             console.log("❌ WebSocket disconnected. Reconnecting...");
//             reconnectTimeoutRef.current = setTimeout(connectWebSocket, 5000);
//         };

//         ws.onerror = (error) => {
//             console.error("⚠️ WebSocket Error:", error);
//             ws.close();
//         };
//     };

//     useEffect(() => {
//         if (userId) {
//             connectWebSocket();
//         }

//         return () => {
//             if (socketRef.current) socketRef.current.close();
//             clearTimeout(reconnectTimeoutRef.current);
//         };
//     }, [userId]);

//     const sendMessage = (message) => {
//         if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
//             console.log("🚀 Sending WebSocket Message:", message);
//             socketRef.current.send(JSON.stringify(message));
//         } else {
//             console.log("⚠️ WebSocket Not Open. Message Not Sent.");
//         }
//     };

//     return (
//         <WebSocketContext.Provider value={{ messages, setMessages, sendMessage }}>
//             {children}
//         </WebSocketContext.Provider>
//     );
// };

// export const useWebSocket = () => useContext(WebSocketContext);
